var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50065 2.83332C7.03652 2.83332 6.5914 3.0177 6.26321 3.34589C5.93502 3.67407 5.75065 4.11919 5.75065 4.58332V6.33332H9.25065V4.58332C9.25065 4.11919 9.06628 3.67407 8.73809 3.34589C8.4099 3.0177 7.96478 2.83332 7.50065 2.83332ZM10.4173 6.33332V4.58332C10.4173 3.80978 10.11 3.06791 9.56304 2.52093C9.01606 1.97395 8.2742 1.66666 7.50065 1.66666C6.7271 1.66666 5.98524 1.97395 5.43826 2.52093C4.89127 3.06791 4.58398 3.80978 4.58398 4.58332V6.33332C3.61749 6.33332 2.83398 7.11682 2.83398 8.08332V11.5833C2.83398 12.5498 3.61749 13.3333 4.58398 13.3333H10.4173C11.3838 13.3333 12.1673 12.5498 12.1673 11.5833V8.08332C12.1673 7.11682 11.3838 6.33332 10.4173 6.33332ZM4.58398 7.49999C4.26182 7.49999 4.00065 7.76116 4.00065 8.08332V11.5833C4.00065 11.9055 4.26182 12.1667 4.58398 12.1667H10.4173C10.7395 12.1667 11.0006 11.9055 11.0006 11.5833V8.08332C11.0006 7.76116 10.7395 7.49999 10.4173 7.49999H4.58398ZM6.33398 9.83332C6.33398 9.18899 6.85632 8.66666 7.50065 8.66666C8.14498 8.66666 8.66732 9.18899 8.66732 9.83332C8.66732 10.4777 8.14498 11 7.50065 11C6.85632 11 6.33398 10.4777 6.33398 9.83332Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ceb30901f2137a5b9c28aea85f92f071.svg";
export { ForwardRef as ReactComponent };